import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box, Typography, MobileStepper } from '@mui/material';

type Step = { title: string; body: React.ReactNode };

export function ProductTourDialog({ open, onClose }: { open: boolean; onClose: () => void }) {
  const steps: Step[] = [
    { title: 'Welcome to Webmail', body: <Typography variant="body2">Read, compose, and organize your email efficiently.</Typography> },
    { title: 'Sidebar & Mailboxes', body: <Typography variant="body2">Switch between Inbox, Sent, Drafts, Archive, and custom folders.</Typography> },
    { title: 'Email List & Preview', body: <Typography variant="body2">Hover for quick actions; click to preview. Use bulk actions when selecting multiple emails.</Typography> },
    { title: 'Compose & Drafts', body: <Typography variant="body2">Use the rich editor, signatures, and attachments. Drafts auto‑save as you type.</Typography> },
    { title: 'Settings (Grouped)', body: <Typography variant="body2">Personal (Profile/Preferences/Security), Email (Identities/Signatures/Vacation/Filters), Advanced (Configuration).</Typography> },
  ];
  const [active, setActive] = React.useState(0);
  React.useEffect(() => { if (!open) setActive(0); }, [open]);
  const done = () => { try { localStorage.setItem('webmail_tour_seen', '1'); } catch {} onClose(); };
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{steps[active].title}</DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 0.5 }}>{steps[active].body}</Box>
        <MobileStepper variant="dots" steps={steps.length} position="static" activeStep={active} sx={{ mt: 2, px: 0 }} nextButton={null} backButton={null} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
        <Box sx={{ flexGrow: 1 }} />
        <Button onClick={() => setActive((v) => Math.max(0, v - 1))} disabled={active === 0}>Back</Button>
        {active < steps.length - 1 ? (
          <Button variant="contained" onClick={() => setActive((v) => Math.min(steps.length - 1, v + 1))}>Next</Button>
        ) : (
          <Button variant="contained" onClick={done}>Done</Button>
        )}
      </DialogActions>
    </Dialog>
  );
}

